<template>
    <v-dialog :value="true" persistent max-width="500px" @click:outside="closeDialog()" v-bind="$attrs"
        :retain-focus="false" v-on="$listeners">
        <v-card>
            <v-card-title>
                <span class="text-h5">Editar material</span>
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-col>
                        <v-row>
                            <v-text-field v-model="value.no" label="Código producto" disabled />
                        </v-row>

                        <v-row>
                            <v-text-field v-model="value.description" label="Descripcion" :disabled="
                                disabled">
                            </v-text-field>
                        </v-row>
                        <v-row>
                            <v-text-field v-model="value.qty" label="Unidades" type="number" :disabled="
                                disabled">
                            </v-text-field>
                        </v-row>
                        <v-row>
                            <v-text-field v-model="value.unitPrice" :disabled="disabled" label="Precio/u" prefix="€"
                                type="number">
                            </v-text-field>
                        </v-row>
                        <v-row>
                            <v-text-field v-model="value.discount" :disabled="
                                disabled" label="Descuento" prefix="%" type="number">
                            </v-text-field>
                        </v-row>
                    </v-col>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-btn color="red darken-1" text @click="handleDelete" :disabled="disabled">
                    Eliminar
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="error" text @click="closeDialog"> Cancelar </v-btn>
                <v-btn text :disabled="disabled" @click="handleSave">
                    Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'MaterialEdit',
    props: {
        value: {
            type: Object,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        closeDialog() {
            this.$emit("close")
        },
        handleSave() {
            this.$emit('saveItem', this.value)
            this.closeDialog()
        },
        handleDelete() {
            this.$emit('deleteItem', this.value)
            this.closeDialog();
        }
    },
}
</script>